// import axios from "axios";

// const storage = {
//     getItem: (key) => localStorage.getItem(key),
//     setItem: (key, value) => localStorage.setItem(key, value),
//     removeItem: (key) => localStorage.removeItem(key),
// };

// const api = axios.create({
//     baseURL: "http://85.198.83.173:3001",
//     timeout: 10000,
//     headers: { "Content-Type": "application/json" },
// });

// const uploadApi = axios.create({
//     baseURL: "https://rem-crm.ru:3001",
//     timeout: 15000,
//     headers: { "Content-Type": "multipart/form-data" },
// });

// const notificationApi = axios.create({
//     baseURL: "http://85.198.83.173:3001",
//     timeout: 10000,
//     headers: { "Content-Type": "application/json" },
// });

// [api, uploadApi, notificationApi].forEach((instance) => {
//     instance.interceptors.request.use(
//         async (config) => {
//             const token = await storage.getItem("@auth_token");
//             if (token) config.headers.Authorization = `Bearer ${token}`;
//             return config;
//         },
//         (error) => Promise.reject(error),
//     );
//     instance.interceptors.response.use(
//         (response) => {
//             console.log("Успех:", response.config.url, response.status);
//             return response;
//         },
//         (error) => {
//             if (error.response) console.log("Ошибка ответа:", error.response.status, error.response.data);
//             else console.log("Сетевая ошибка:", error.message);
//             return Promise.reject(error);
//         },
//     );
// });

// export const authAPI = {
//     login: (phone, password) => api.post("/auth/login", { phone, password }),
//     register: (userData) => api.post("/auth/register", userData),
//     logout: () => api.post("/auth/logout"),
//     forgotPassword: (phone) => api.post("/auth/forgot-password", { phone }),
// };

// export const ordersAPI = {
//     viewOrder: (orderId, userId) => api.post(`/v1/orders/getOrder/viewOrder`, { orderId, userId }),
//     takeOrderWithUser: (orderId, userId) => api.post(`/v1/orders/getOrder/takeOrder`, { orderId, userId }),
//     callClient: (orderId, userId) => api.post("/v1/orders/getOrder/callClient", { orderId, userId }),
//     completeOrder: (data) => api.post("/v1/orders/getOrder/complete", { data }),
//     getOrderById: (orderId, userId) => api.post("/v1/orders/getOrder/getById", { orderId, userId }),
// };

// export const reportsAPI = {
//     markOrderAsPaid: (orderId, userId) => api.post("/v1/orders/getReports/markPaid", { orderId, userId }),
// };

// export const profileAPI = {
//     changePassword: (userId, oldPassword, newPassword) => api.post("/v1/user/getMaster/changePassword", { userId, oldPassword, newPassword }),
//     getCurrentUser: (userId) => api.post("/v1/user/getMaster/me", { userId }),
// };

// export const workSettingsAPI = {
//     updateWorkSettings: (data) => api.post("/v1/user/getMaster/workSettings", data),
//     getWorkSettings: (data) => api.post("/v1/user/getMaster/getWorkSettings", data),
// };

// export const techniquesAPI = {
//     getTechniques: () => api.get("/v1/lib/getTechnic"),
// };

// export const citiesAPI = {
//     getCities: () => api.get("/auth/cities"),
// };

// export const servicesAPI = {
//     getServices: (technicId) => api.post("/v1/lib/getServices", { technic: technicId }),
// };

// export const uploadAPI = {
//     uploadPhoto: (formData) => uploadApi.post("/upload", formData),
// };

// export const notificationAPI = {
//     savePushToken: (userId, token) => notificationApi.post("/v1/user/getMaster/savePushToken", { userId, token }),
// };

// export default api;

import axios from "axios";

const storage = {
    getItem: (key) => localStorage.getItem(key),
    setItem: (key, value) => localStorage.setItem(key, value),
    removeItem: (key) => localStorage.removeItem(key),
};

// Основной API – теперь через наш домен
const api = axios.create({
    baseURL: "/api",
    timeout: 10000,
    headers: {
        "Content-Type": "application/json",
    },
});

// API для загрузки файлов
const uploadApi = axios.create({
    baseURL: "/upload",
    timeout: 15000,
    headers: { "Content-Type": "multipart/form-data" },
});

// API для уведомлений
const notificationApi = axios.create({
    baseURL: "/api",
    timeout: 10000,
    headers: { "Content-Type": "application/json" },
});

[api, uploadApi, notificationApi].forEach((instance) => {
    instance.interceptors.request.use(
        async (config) => {
            const token = await storage.getItem("@auth_token");
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error),
    );
    instance.interceptors.response.use(
        (response) => {
            console.log("Успех:", response.config.url, response.status);
            return response;
        },
        (error) => {
            if (error.response) {
                console.log("Ошибка ответа:", error.response.status, error.response.data);
            } else {
                console.log("Сетевая ошибка:", error.message);
            }
            return Promise.reject(error);
        },
    );
});

// ========== Аутентификация ==========
export const authAPI = {
    login: (phone, password) => api.post("/auth/login", { phone, password }),
    register: (userData) => api.post("/auth/register", userData),
    logout: () => api.post("/auth/logout"),
    forgotPassword: (phone) => api.post("/auth/forgot-password", { phone }),
};

// ========== Заказы ==========
export const ordersAPI = {
    viewOrder: (orderId, userId) => api.post(`/v1/orders/getOrder/viewOrder`, { orderId, userId }),
    takeOrderWithUser: (orderId, userId) => api.post(`/v1/orders/getOrder/takeOrder`, { orderId, userId }),
    callClient: (orderId, userId) => api.post("/v1/orders/getOrder/callClient", { orderId, userId }),
    completeOrder: (data) => api.post("/v1/orders/getOrder/complete", { data }),
    getOrderById: (orderId, userId) => api.post("/v1/orders/getOrder/getById", { orderId, userId }),
    agreeWithClient: (orderId, userId, comment) => api.post("/v1/orders/getOrder/agree", { orderId, userId, comment }),
};

// ========== Отчеты ==========
export const reportsAPI = {
    markOrderAsPaid: (orderId, userId) => api.post("/v1/orders/getReports/markPaid", { orderId, userId }),
};

// ========== Профиль ==========
export const profileAPI = {
    changePassword: (userId, oldPassword, newPassword) => api.post("/v1/user/getMaster/changePassword", { userId, oldPassword, newPassword }),
    getCurrentUser: (userId) => api.post("/v1/user/getMaster/me", { userId }),
};

// ========== Рабочие настройки ==========
export const workSettingsAPI = {
    updateWorkSettings: (data) => api.post("/v1/user/getMaster/workSettings", data),
    getWorkSettings: (data) => api.post("/v1/user/getMaster/getWorkSettings", data),
};

// ========== Техника ==========
export const techniquesAPI = {
    getTechniques: () => api.get("/v1/lib/getTechnic"),
};

// ========== Города ==========
export const citiesAPI = {
    getCities: () => api.get("/auth/cities"),
};

// ========== Услуги ==========
export const servicesAPI = {
    getServices: (technicId) => api.post("/v1/lib/getServices", { technic: technicId }),
};

// ========= Файлы =========
export const uploadAPI = {
    uploadPhoto: (formData) => uploadApi.post("/upload", formData),
};

// ========= Уведомления (push-токены) =========
export const notificationAPI = {
    savePushToken: (userId, token) => notificationApi.post("/v1/user/getMaster/savePushToken", { userId, token }),
};

export default api;
